module.exports = __webpack_public_path__ + "img/logo-partners.096a6318.svg";